'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remainingLazyLoads = exports.loadAll = exports.load = exports.update = exports.init = undefined;

var _vanillaLazyload = require('vanilla-lazyload');

var _vanillaLazyload2 = _interopRequireDefault(_vanillaLazyload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Built but not used - saving for potential use later (See below)
// const dom = {
//   manualLazyLoadItems: '[ll-manual-item]',
// };

// Currently not working
var finish = function finish() {
  document.dispatchEvent(new Event('lazyload.finish'));
};

var initLazyLoad = function initLazyLoad() {
  window.lazy = new _vanillaLazyload2.default({
    callback_finish: finish
  });
};

var init = exports.init = function init() {
  initLazyLoad();
  console.log('[BVA] Component Loaded: LazyLoader');
};

var update = exports.update = function update() {
  window.lazy.update();
};

var load = exports.load = function load(element) {
  window.lazy.load(element);
};

var loadAll = exports.loadAll = function loadAll() {
  window.lazy.loadAll();
};

var remainingLazyLoads = exports.remainingLazyLoads = function remainingLazyLoads() {
  return window.lazy.toLoadCount;
};

// Built but not used - saving for potential use later
// const activateManualLoadLoadItemSingle = (index, element) => {
//   const src = $(element).attr('ll-src') || false;
//   const srcset = $(element).attr('ll-srcset') || false;
//   if (src) $(element).attr('src', src);
//   if (srcset) $(element).attr('srcset', srcset);
//   $(element).addClass('loaded');
// };

// export const activateManualLazyLoadItems = ($context) => {
//   const $inactiveLazyItems = $(dom.manualLazyLoadItems, $context).filter(':not(.loaded)');
//   if (!$inactiveLazyItems.length) return;
//   $inactiveLazyItems.each(activateManualLoadLoadItemSingle);
// };